import React from 'react';

// Resolves the document/window that the ref'd node actually lives in, so DOM
// reads (getComputedStyle, resize listeners, body style) target the iframe's
// realm when a component renders inside the builder preview rather than the
// host page. Attach the returned `rootRef` to any rendered node; falls back to
// the global document/window when unmounted or not framed.
function useOwnerRealm() {
    const rootRef = React.useRef(null);
    const getDocument = () => (rootRef.current && rootRef.current.ownerDocument) || document;
    const getWindow = () => getDocument().defaultView || window;
    return { getDocument, getWindow, rootRef };
}

export default useOwnerRealm;
